module.exports = __webpack_public_path__ + "img/dice-six.5adf48bc.svg";